module.exports = __webpack_public_path__ + "static/media/RL_CHICA.31af1a29.webp";